import qs from 'qs';

import { ADMIN_SCOPED_ROLES, getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { IListCasesParams } from './listAllCases';
import { ICase } from './types/ICase';

export const getOneCase = async (case_id: number, params?: IListCasesParams, userRole?: string): Promise<ICase> => {
  if (!case_id) {
    throw new Error('Case ID is required');
  }

  let queryParams: Record<string, any> = {};

  if (params && typeof params === 'object') {
    queryParams = { ...params };
  }

  const { userRoleName, ...rest } = queryParams;

  const effectiveRole =
    (typeof userRole === 'string' && userRole !== '' ? userRole : undefined) ??
    (typeof userRoleName === 'string' && userRoleName !== '' ? userRoleName : undefined);

  const prefix =
    effectiveRole && ADMIN_SCOPED_ROLES.has(effectiveRole) ? '/admin' : getStaffScopedApiPrefix(effectiveRole);

  const baseUrl = prefix ? `${prefix}/cases` : '/cases';

  const queryString = qs.stringify(rest, {
    skipNulls: true,
    arrayFormat: 'repeat',
  });

  const { data } = await client.get(queryString ? `${baseUrl}/${case_id}?${queryString}` : `${baseUrl}/${case_id}`);

  return data;
};
